<template>
  <div class="card card-custom gutter-b example example-compact">
    <div class="card-header">
      <div class="card-title">
        <router-link to="/admin/faq" class="mr-5">
          <b-icon icon="arrow-left" scale="1.5"></b-icon>
        </router-link>
        <h3>Edit FAQ</h3>
      </div>
    </div>
    <div class="card-body">
      <div class="listing-form-main">
        <ValidationObserver ref="faqForm">
          <b-form class="form" @submit.stop.prevent="onSubmit">
            <div class="row">
              <div class="col-md-8 form-div">
                <b-form-group>
                  <ValidationProvider
                    rules="required"
                    v-slot="{ errors }"
                    :custom-messages="{
                      required: 'Question is required.',
                    }"
                  >
                    <v-text-field
                      :error-messages="errors[0]"
                      autocomplete="new-password"
                      v-model="form.question"
                      label="Question"
                      outlined
                    ></v-text-field>
                  </ValidationProvider>
                </b-form-group>

                <b-form-group>
                  <ValidationProvider
                    rules="required"
                    v-slot="{ errors }"
                    :custom-messages="{
                      required: 'Answer is required.',
                    }"
                  >
                    <!-- <vue-editor
                      placeholder="Answer..."
                      :class="errors[0] ? 'error-outline' : ''"
                      v-model="form.answer"
                    ></vue-editor> -->
                    <ckeditor
                      v-model="form.answer"
                      :config="editorConfig"
                      :error-messages="errors[0]"
                    ></ckeditor>
                  </ValidationProvider>
                </b-form-group>

                <b-form-group class="mt-5">
                  <v-switch
                    v-model="status"
                    inset
                    :label="status == true ? 'Enabled' : 'Disabled'"
                    class="d-inline-block"
                  ></v-switch>
                </b-form-group>

                <div class="fo-row-btn text-right">
                  <v-btn class="submit-btn-fill-outline" @click="goToBack">
                    Cancel
                  </v-btn>
                  <v-btn
                    type="submit"
                    :disabled="isDisabled"
                    ref="kt_form_submit_btn"
                    class="submit-btn-fill-color"
                  >
                    {{ submitText }}
                  </v-btn>
                </div>
              </div>
            </div>
          </b-form>
        </ValidationObserver>
      </div>
    </div>
    <notifications group="faqs" position="bottom right" />
  </div>
</template>

<script>
import Vue from "vue";
import { mapGetters } from "vuex";
import axios from "axios";
import Notifications from "vue-notification";
import JwtService from "@/core/services/jwt.service";
import HtmlClass from "@/core/services/htmlclass.service";
import KTScrollTop from "@/components/admin/layout/extras/ScrollTop";
import Loader from "@/components/admin/layout/Loader.vue";
import { VueEditor, Quill } from "vue2-editor";
import {
  ADD_BODY_CLASSNAME,
  REMOVE_BODY_CLASSNAME,
} from "@/core/services/store/htmlclass.module.js";
import adminAPI from "@/api/admin";
import CKEditor from "ckeditor4-vue";
Vue.use(CKEditor);

Vue.use(Notifications);
export default {
  name: "EditFaq",
  created() {
    if (!this.isAuthenticated) {
      this.$router.push({ name: "Login" });
    } else {
      // show page loading
      this.$store.dispatch(ADD_BODY_CLASSNAME, "page-loading");
      HtmlClass.init(this.layoutConfig());
      this.getFaqData();
    }
  },
  data() {
    return {
      submitText: "Submit",
      formError: false,
      userId: null,
      btnDisable: false,
      status: false,
      form: {
        question: null,
        answer: null,
      },
      radioItems: [
        {
          key: "Enable",
          value: "1",
        },
        {
          key: "Disable",
          value: "0",
        },
      ],
      editorConfig: {language: 'de',scayt_sLang : 'de_DE'},
    };
  },
  components: {
    // VueEditor,
  },
  methods: {
    goToBack() {
      this.$router.push({ name: "room-faqs" });
    },
    removeImage() {
      this.form.file = null;
      this.currentImage = null;
    },
    handleRemoveImage() {
      this.form.file = null;
      this.currentImage = null;
    },
    getFaqData() {
      adminAPI
        .editFaq({ id: this.$route.params.id })
        .then((response) => {
          if (response.status == "success") {
            this.form.question = response.data.question;
            this.form.answer = response.data.answer;

            this.status = response.data.is_status == 1 ? true : false;

            this.$store.dispatch(REMOVE_BODY_CLASSNAME, "page-loading");
          } else {
            this.$store.dispatch(REMOVE_BODY_CLASSNAME, "page-loading");
            this.$notify({
              group: "faqs",
              type: "error",
              position: "bottom right",
              text: response.msg,
              duration: 3000,
            });
          }
        })
        .catch((err) => {
          this.$store.dispatch(REMOVE_BODY_CLASSNAME, "page-loading");
          this.$notify({
            group: "faqs",
            type: "error",
            position: "bottom right",
            text: err,
            duration: 3000,
          });
        });
    },
    uploadFile(file) {
      setTimeout(() => {
        if (file.status == "queued") {
          this.imageChanged = "1";
          this.form.file = file;
        }
      }, 1000);
    },
    onSubmit() {
      this.$refs.faqForm.validate().then((success) => {
        if (success && this.form.file !== null) {
          this.btnDisable = true;
          this.submitText = "Submitting...";
          let fd = new FormData();
          fd.append("question", this.form.question);
          fd.append("answer", this.form.answer);
          fd.append("id", this.$route.params.id);
          fd.append("status", this.status == true ? "1" : "0");
          setTimeout(() => {
            adminAPI
              .updateFaq(fd)
              .then((response) => {
                if (response.status == "success") {
                  this.submitText = "Submit";
                  this.btnDisable = false;
                  this.$notify({
                    group: "faqs",
                    type: "success",
                    position: "bottom right",
                    text: response.msg,
                    duration: 5000,
                  });
                  setTimeout(() => {
                    this.$router.push({ name: "faq" });
                  }, 2000);
                } else {
                  this.btnDisable = false;
                  this.submitText = "Submit";

                  this.$notify({
                    group: "faqs",
                    type: "error",
                    position: "bottom right",
                    text: response.msg,
                    duration: 5000,
                  });
                }
              })
              .catch((err) => {
                this.btnDisable = false;
                this.submitText = "Submit";
                this.$notify({
                  group: "faqs",
                  type: "error",
                  position: "bottom right",
                  text: err,
                  duration: 5000,
                });
              });
          }, 2000);
        } else {
          this.formError = true;
          this.btnDisable = false;
          this.submitText = "Submit";
        }
      });
    },
  },
  computed: {
    ...mapGetters([
      "isAuthenticated",
      "breadcrumbs",
      "pageTitle",
      "layoutConfig",
      "currentUser",
    ]),
    /**
     * Check if the page loader is enabled
     * @returns {boolean}
     */
    loaderEnabled() {
      return !/false/.test(this.layoutConfig("loader.type"));
    },
    /**
     * Check if container width is fluid
     * @returns {boolean}
     */
    contentFluid() {
      return this.layoutConfig("content.width") === "fluid";
    },
    /**
     * Page loader logo image using require() function
     * @returns {string}
     */
    loaderLogo() {
      return process.env.BASE_URL + this.layoutConfig("loader.logo");
    },
    /**
     * Check if the left aside menu is enabled
     * @returns {boolean}
     */
    asideEnabled() {
      return !!this.layoutConfig("aside.self.display");
    },
    /**
     * Set the right toolbar display
     * @returns {boolean}
     */
    toolbarDisplay() {
      // return !!this.layoutConfig("toolbar.display");
      return true;
    },
    /**
     * Set the subheader display
     * @returns {boolean}
     */
    subheaderDisplay() {
      return !!this.layoutConfig("subheader.display");
    },

    isDisabled: function () {
      return this.btnDisable;
    },
  },
};
</script>

<style scoped>
h3 {
  font-family: "ubuntu";
  color: #000;
}

.form-div {
  margin: auto;
}

.form-errors {
  color: red;
}

.submit-button {
  background-color: #3d5a80 !important;
}

.submit-button:hover {
  background-color: #002c47 !important;
}

.spinner.spinner-right {
  padding-right: 3.5rem !important;
}

.remove-icon {
  cursor: pointer;
  position: absolute;
  top: 0;
}

.dropzone .dz-preview .dz-progress {
  /* progress bar covers file name */
  display: none !important;
  opacity: 0 !important;
}
</style>
